export enum TabsKRMODAL {
	GENERAL = 0,
	MILESTONE = 1,
	FREQUENCY = 2,
	CHECK_IN = 3,
	INDICATORS = 4,
	PROJECTS = 5
}

export enum MeasurementType{
    NUMERIC = "1",
    PERCENTAGE = "2",
    MONETARY_VALUE = "3",
    MILESTONE = "4"
}

export enum MeasurementForm{
    KEY_RESULTS = "1",
    INICIATIVES = "2",
    PROJECTS = "3",
    INDICATORS = "4"
}

export enum CheckInFrequencyType{
    NO_FREQUENCY = "0",
    WEEKLY = "1",
    MONTLHY = "2"
}

interface IOrgChartKeyResultsRef{
    openModalDeleteKr: (id: number, title: string, onCallback?: Function) => void;
    openModalAddOrChangeKr: (id?: number, okrParentId?: number, okrParentTitle?: string, onCallback?: Function, tabInitSelected?: TabsKRMODAL, disabled?: boolean) => void;
}


export default IOrgChartKeyResultsRef;
